import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { LucideIconInput } from '@lucide/angular';

export type ButtonTypes =
  | 'primary'
  | 'secondary'
  | 'ghost'
  | 'alert'
  | 'neutral'
  | 'dark'
  | 'secondary-neutral'
  | 'soft-neutral'
  | 'tertiary-neutral'
  | 'tertiary-color'
  | 'link-neutral'
  | 'link-color'
  | 'primary-alert'
  | 'secondary-alert'
  | 'tertiary-alert'
  | 'link-alert'
  | 'tag'
  | 'primary-pink'
  | 'primary-green'
  | 'primary-coral'
  | 'smoke'
  | 'soft-accent'
  | 'inverse'
  | 'circle'
  | 'circle-alert';

export type ButtonSizes = 'xs' | 's' | 'sm' | 'm' | 'l' | 'xl';

@Component({
  selector: 'ptl-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, IconComponent],
})
export class ButtonComponent implements OnInit {
  @Input() type: ButtonTypes = 'primary';
  @Input() size: ButtonSizes = 'm';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() highlighted = false;
  @Input() fullWidth = false;

  @Input() text?: string;
  @Input() icon?: LucideIconInput;
  @Input() iconSuffix?: LucideIconInput;
  @Input() ariaLabel?: string;
  @Input() ariaExpanded: boolean | null = null;
  /** Looks disabled and `clicked` stays silent, but unlike `disabled` the click still reaches a surrounding tooltip. */
  @Input() ariaDisabled = false;

  @Input() iconStrokeWidth = 1.5;
  @Output() clicked = new EventEmitter<void>();

  isIconOnly = false;

  ngOnInit(): void {
    this.isIconOnly = !this.text && (!!this.icon || !!this.iconSuffix);
  }

  onClick(): void {
    if (!this.disabled && !this.loading && !this.ariaDisabled) {
      this.clicked.emit();
    }
  }
}
